let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lrF0k")).then(() => parcelRequire('1K2XC'));